import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ProductForm from '../components/admin/ProductForm';

const EditProductPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  return (
    <ProductForm
      isEditMode
      productId={Number(id)}
      onSubmitSuccess={() => navigate('/products')}
    />
  );
};

export default EditProductPage;
